import { render } from "./RegisterView.vue?vue&type=template&id=4599134f&scoped=true&ts=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"

import "./RegisterView.vue?vue&type=style&index=0&id=4599134f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4599134f"]])

export default __exports__